// extracted by mini-css-extract-plugin
export default {"tableRoot":"VaultActivity-module__tableRoot--udgjW","tableWrapper":"VaultActivity-module__tableWrapper--hMK22","cellText":"VaultActivity-module__cellText--JFNOg"};